// action - state management
import * as actionTypes from './actions';

export const initialState = {
    openRoleSelection: false,
    roles: [],
    selectedRole: null,
    creds: null
};

const roleReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_CREDS:
            return {
                ...state,
                creds: action?.creds
            };
        case actionTypes.HANDLE_ROLE_SELECTION:
            return {
                ...state,
                openRoleSelection: action?.open
            };
        case actionTypes.SET_ROLES:
            return {
                ...state,
                roles: action?.roles
            };
        case actionTypes.SWITCH_ROLE:
            return {
                ...state,
                selectedRole: action?.selectedRole
            };
        case actionTypes.LOGOUT:
            return initialState;
        default:
            return state;
    }
};

export default roleReducer;
